import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import api from '../utils/api';
import type { LoginRequest, User } from '../types';

interface LoginResponse {
  success: boolean;
  data?: {
    token: string;
    user: User;
  };
  error?: string;
}

export default function Login() {
  const navigate = useNavigate();
  const { setAuth } = useAuthStore();
  const [form] = Form.useForm();

  const handleSubmit = async (values: LoginRequest) => {
    try {
      const response = await api
        .post('auth/login', { json: values })
        .json<LoginResponse>();

      if (response.success && response.data) {
        setAuth(response.data.token, response.data.user);
        message.success('登录成功');
        navigate('/s/dashboard', { replace: true });
      } else {
        message.error(response.error || '登录失败');
      }
    } catch (error) {
      // ky 在收到非 2xx 响应时会抛出 HTTPError
      console.error('Login error:', error);
      if (error && typeof error === 'object' && 'response' in error) {
        const httpError = error as { response: Response };
        try {
          const errorResponse = await httpError.response.json() as LoginResponse;
          message.error(errorResponse?.error || '登录失败，请检查用户名和密码');
        } catch {
          message.error('登录失败，请检查用户名和密码');
        }
      } else {
        message.error('登录失败，请检查用户名和密码');
      }
    }
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f0f2f5'
    }}>
      <Card title="SF Jump 登录" style={{ width: 400 }}>
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="用户名" size="large" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="密码" size="large" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large">
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
